import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import FeaturedServices from './components/FeaturedServices';
import WhyUs from './components/WhyUs';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '91美 - 您值得信赖的美业服务平台',
            description:
              '91美汇聚海量优质美容、美发、美甲、美体项目，为您提供一站式美丽解决方案。',
            url: 'https://91mei.com',
            isPartOf: {
              '@type': 'WebSite',
              name: '91美',
              url: 'https://91mei.com',
            },
            about: {
              '@type': 'Organization',
              name: '91美',
              url: 'https://91mei.com',
            },
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <CategorySection />
          <FeaturedServices />
          <WhyUs />
          <ArticlesSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}